import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { translate } from "react-i18next";
import DefaultButton from './../../../components/DefaultButton';
import GhostButton from './../../../components/GhostButton';
import SelectInput from './../../../components/SelectInput';
import { choseProject } from './../../../actions/auth';
import loading from './../../../utilities/loading';
import { signOut } from './../../../actions/auth';
import messageManager from '../../../utilities/messageManager';

const SelectLabel = styled.p`
  margin: 5px 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 15px;
`;

const Wrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(100% - 30px);
  min-height: 265px;
`;

const Greetings = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    font-size: 15px;
    color: #265a9c;
    margin: 20px 0;
`;

export class ChooseProjectForm extends React.Component {
    constructor() {
        super();
        this.state = {
            projects: [],
            selectedProject: null,
            confirmBtnDisabled: false
        };
    }

    handleSubmit() {
        const { choseProject, axiosInstance } = this.props;
        const { selectedProject } = this.state;

        loading.start();
        this.setState({ confirmBtnDisabled: true });

        choseProject(
            selectedProject,
            axiosInstance
        );
    }

    componentDidMount() {
        const { BASE_URL, axiosInstance } = this.props;
        axiosInstance.get(`${BASE_URL}workspaces`)
            .then((response) => {
                const projects = response.data;
                this.setState({
                    projects: projects,
                    selectedProject: projects.length > 0 ? projects[0] : null
                });
                this.selectNode.domNode.focus();
            });
    }

    componentDidUpdate(prevProps) {
        const { t, message } = this.props;
        if (prevProps.message !== message && message.type === 'error') {
            messageManager.show({
                type: 'error',
                text: t(message.text),
            });
            
            loading.stop();
            this.setState({ confirmBtnDisabled: false });
        }        
    }

    calculateSelectSize(n){
        if (n < 5) return '5';
        if (n > 15) return '15';
        return `${n}`;
    }

    render() {
        const { t, roles, userName } = this.props;
        const { projects, selectedProject, confirmBtnDisabled } = this.state;
        const isAdmin = (roles === 'Admin' || roles === 'SuperAdmin');

        return (
            <Wrapper onSubmit={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.handleSubmit();
            }}>
                <input type="submit" value="Submit" style={{ display: 'none' }} />
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        alignItems: 'flex-start',
                        justifyContent: 'center',
                    }}
                >
                    <Greetings>
                        {t('Welcome')}
                        <b>&nbsp;{userName}</b>!
                    </Greetings>
                    <SelectLabel>
                        {t('Choose workspace')}:
                    </SelectLabel>
                    <SelectInput
                        size={this.calculateSelectSize(projects.length)}
                        style={{
                            width: '100%',
                        }}
                        value={selectedProject ? selectedProject.id : 0}
                        onChange={(e) => {
                            const selectedProject = projects.find(project => {
                                return project.id === Number(e.target.value);
                            })
                            this.setState({
                                selectedProject: selectedProject
                            })
                        }}
                        ref={(node => { this.selectNode = node })}
                    >
                        {projects.map((project) => {
                            return (
                                <option
                                    style={{
                                        borderRadius: '4px'
                                    }}
                                    key={`project_select_${project.id}`}
                                    value={project.id}>
                                    {roles === 'SuperAdmin'
                                        ? `${project.customerName} - ${project.name}`
                                        : `${project.name}`
                                    }
                                </option>
                            )
                        })}
                    </SelectInput>
                </div>

                <div
                    style={{
                        display: 'flex',
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: 'auto',
                        marginBottom: '16px',
                    }}
                >
                    <GhostButton
                        style={{
                            height: '30px',
                            width: '90px',
                            marginRight: '5px',
                            fontSize: '14px',
                        }}
                        onClick={() => {
                            this.props.signOut();
                        }}
                    >
                        {t('SignOut')}
                    </GhostButton>

                    {isAdmin
                        ? (
                            <Link
                                style={{
                                    textDecoration: 'none',
                                    color: '#265a9c',
                                    marginLeft: '5px',
                                    marginRight: '5px',
                                }}
                                to='/admin'>
                                <GhostButton
                                    style={{
                                        height: '30px',
                                        width: '140px',
                                        fontSize: '14px',
                                    }}>
                                    {t('Manage workspaces')}
                                </GhostButton>
                            </Link>
                        )
                        : ''
                    }

                    <DefaultButton
                        style={{
                            marginLeft: '5px',
                            height: '30px',
                            width: '100px',
                        }}
                        disabled={!selectedProject || confirmBtnDisabled}
                        onClick={() => {
                            this.handleSubmit();
                        }}>
                        {t('Confirm')}
                    </DefaultButton>
                </div>
            </Wrapper>
        );
    }
};

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    roles: state.auth.get('roles'),
    userName: state.auth.get('userName'),
    message: state.auth.get('message'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    choseProject,
    signOut,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(ChooseProjectForm));


// WEBPACK FOOTER //
// ./src/containers/signIn/chooseProjectForm/ChooseProjectForm.jsx